<div class="fizz-center-content" data-testid="loading-spinner">
  <div
    class="fizz-icon-spinner fizz-stack-16"
    style="margin-top: 1.25rem; height: 40px; width: 40px;"
  />
</div>
